export const lan = {
  add_table: "devices",
};

export default lan;
